<template>
  <v-card>
    <v-card-title>{{title}}</v-card-title>
    <v-card-text>
      This is another dummy with value {{localValue}}
      <p>Clicking "save" emits "input" event</p>
    </v-card-text>
    <v-card-actions>
      <v-btn
        color="primary"
        @click.prevent="handleAddClick"
        href="#"
      >Add +</v-btn>
      <v-btn
        color="secondary"
        @click.prevent="handleSaveClick"
        href="#"
      >Save</v-btn>
    </v-card-actions>

  </v-card>
</template>
<script>
export default {
  name: 'DummyComponent',
  props: {
    title: {
      type: String,
      default: ''
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      localValue: this.value
    }
  },

  methods: {
    handleAddClick () {
      this.localValue++
    },
    handleSaveClick (e) {
      this.$emit('input', this.localValue)
    }
  }
}
</script>
